(function () {
  'use strict';

  var initializedSections = new WeakSet();

  function track(eventName) {
    if (!eventName || !Array.isArray(window.dataLayer)) return;

    window.dataLayer.push({
      event: eventName,
      page_context: 'founder_connect'
    });
  }

  function escapeVCard(value) {
    return String(value || '')
      .replace(/\\/g, '\\\\')
      .replace(/\r?\n/g, '\\n')
      .replace(/;/g, '\\;')
      .replace(/,/g, '\\,');
  }

  function addLine(lines, key, value) {
    if (value) lines.push(key + ':' + escapeVCard(value));
  }

  function buildVCard(button) {
    var data = button.dataset;
    var lines = [
      'BEGIN:VCARD',
      'VERSION:3.0',
      'N:' + escapeVCard(data.lastName) + ';' + escapeVCard(data.firstName) + ';;;'
    ];

    addLine(lines, 'FN', data.fullName);
    addLine(lines, 'ORG', data.company);
    addLine(lines, 'TITLE', data.title);
    addLine(lines, 'TEL;TYPE=CELL', data.phone);
    addLine(lines, 'EMAIL;TYPE=INTERNET,WORK', data.email);
    addLine(lines, 'URL;TYPE=WORK', data.website);
    addLine(lines, 'X-SOCIALPROFILE;TYPE=linkedin', data.linkedin);
    addLine(lines, 'X-SOCIALPROFILE;TYPE=instagram', data.instagram);
    lines.push('END:VCARD');

    return lines.join('\r\n');
  }

  function downloadContact(button, section) {
    var card = buildVCard(button);
    var fullName = button.dataset.fullName || 'FarmFetch contact';
    var fileName = fullName
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-|-$/g, '');
    var blob = new Blob([card], { type: 'text/vcard;charset=utf-8' });
    var url = URL.createObjectURL(blob);
    var download = document.createElement('a');
    var status = section.querySelector('[data-ff-contact-status]');

    download.href = url;
    download.download = (fileName || 'farmfetch-contact') + '.vcf';
    download.hidden = true;
    document.body.appendChild(download);
    download.click();
    download.remove();

    window.setTimeout(function () {
      URL.revokeObjectURL(url);
    }, 1000);

    if (status) status.textContent = fullName + '’s contact card is ready to save.';
    track('save_contact_click');
  }

  function initializeSection(section) {
    if (initializedSections.has(section)) return;
    initializedSections.add(section);

    track('founder_connect_view');

    section.addEventListener('click', function (event) {
      var saveButton = event.target.closest('[data-ff-save-contact]');
      var trackedLink = event.target.closest('[data-ff-event]');

      if (saveButton && section.contains(saveButton)) {
        downloadContact(saveButton, section);
        return;
      }

      if (trackedLink && section.contains(trackedLink)) {
        track(trackedLink.dataset.ffEvent);
      }
    });
  }

  function initialize(root) {
    if (root.matches && root.matches('[data-ff-connect]')) initializeSection(root);
    root.querySelectorAll('[data-ff-connect]').forEach(initializeSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initialize(document);
    });
  } else {
    initialize(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initialize(event.target);
  });
})();
